import React, { useEffect, useState } from 'react';
import { Coins } from 'lucide-react';
import { NeonButton } from './ui/NeonButton';
import { useOptIn } from './OptInContext';
const LOGO = 'https://cdn.magicpatterns.com/uploads/a1yEvjwPoVhmQ4vDr2ji7N/583093709_17843682975615978_7496880889785499115_n.jpg';
const BUY_TOKENS_URL = 'https://app.clawplanetarcade.com/buytokens';
const links = [{
  label: 'Prizes',
  href: '#prizes'
}, {
  label: 'How to Play',
  href: '#how-it-works'
}, {
  label: 'Leaderboard',
  href: 'https://app.clawplanetarcade.com/leaderboard',
  external: true
}, {
  label: 'Account',
  href: 'https://app.clawplanetarcade.com/account',
  external: true
}, {
  label: 'Find Us',
  href: '#location'
}];
export function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const {
    openOptIn
  } = useOptIn();
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className={['fixed top-0 inset-x-0 z-50 transition-all duration-300', scrolled ? 'bg-[#05010f]/85 backdrop-blur-md border-b border-purple-500/30 shadow-[0_0_24px_rgba(168,85,247,0.25)]' : 'bg-transparent border-b border-transparent'].join(' ')} data-id="element-90">
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 sm:px-6" data-id="element-91">
        <a href="#top" className="flex items-center gap-3 group" aria-label="Claw Planet Arcade home" data-id="element-92">
          <img src={LOGO} alt="Claw Planet Arcade logo" className="h-10 w-10 rounded-full object-cover ring-2 ring-purple-400/70 shadow-[0_0_16px_rgba(168,85,247,0.7)] transition-transform group-hover:scale-110" data-id="element-93" />
          <span className="hidden font-display text-base font-extrabold tracking-wide text-white sm:block" data-id="element-94">
            CLAW <span className="neon-purple" data-id="element-95">PLANET</span> ARCADE
          </span>
        </a>

        <div className="hidden items-center gap-7 lg:flex" data-id="element-96">
          {links.map(l => <a key={l.href} href={l.href} {...l.external ? {
          onClick: (e: React.MouseEvent) => {
            e.preventDefault();
            openOptIn(l.href);
          }
        } : {}} className="font-display text-sm font-semibold uppercase tracking-wider text-purple-100/80 transition-colors hover:text-cyan-200 hover:[text-shadow:0_0_10px_rgba(34,211,238,0.8)]" data-id="element-97">
              {l.label}
            </a>)}
        </div>

        <NeonButton href={BUY_TOKENS_URL} gated color="pink" pulse className="!px-4 !py-2 !text-xs sm:!px-6 sm:!text-sm" data-id="element-98">
          <Coins className="h-4 w-4" aria-hidden="true" data-id="element-99" />
          Buy Tokens
        </NeonButton>
      </nav>
    </header>;
}